
import { Validator, Validators } from './validation'
import _ from "lodash";

export const requiredValidator = colName => new Validator(
  (value) => {
    value = String(value).trim();
    return value !== void 0 && value !== null && value !== ''
  },
  `${colName} is required`
);

export const dollarValidator = colName => new Validator(
  (value) => /^\d+\.[\d]{2}$/.test(value),
  `${colName} must have the following format: 99.99`
);

export const integerValidator = colName => new Validator(
  (value) => /^[0-9]([0-9]+)?$/.test(value),
  `${colName} must be integer`
);

const regexValidator = (colName, regexp, type) => {
  const rxp = _.isRegExp(regexp) ? regexp : new RegExp(regexp);
  return new Validator(value => _.isNil(value) || _.eq(value, "") || rxp.test(value),
    value => {
      const msg = type === 'numeric' ? 
      `[${value}] is not a valid value for ${colName}` : 'Permitted chars are alpha-numeric and space';
      return msg;
    })
};

const numericValueValidator = colName => {
  return regexValidator(colName, /^\d+$/, 'numeric')
};

const alphaNumericValueValidator = colName => {
  return regexValidator(colName, '^[0-9a-zA-Z ]+$', 'alphaNumeric')
};

const positiveNumberValidator = colName =>
    new Validator(val => _.chain(val).toNumber().gt(0).value(), `${colName} requires positive numeric values`);

const uniqValidator = colName => message => new Validator((val, rowData, dataset) => { 
  let completedProducts =  _.filter(dataset,{ 'Status': 'Complete' });
  completedProducts = completedProducts.filter(product__ => product__.ProductId === undefined ? true : product__.ProductId.indexOf("/") === -1);
  const allVals = _.chain(completedProducts).reject({ImportRowNo: _.get(rowData, "ImportRowNo")}).map(colName).value();
  
  if(rowData.ProductId !== undefined && rowData.ProductId.indexOf("/") > -1) {
    return true;
  } else {
    return !_.includes(allVals, Number(val));
  }
}, `${message} has to be unique`); 
    

const uniqCombinationValidator = colNames => new Validator((val, rowData, dataset) => {
  const getVal = _.template(_.chain(colNames).map(a => `<%= ${a} %>`).join(',').value());
  const allVals = _.chain(dataset).reject({ImportRowNo: _.get(rowData, "ImportRowNo")}).map(getVal).value();
  return !_.includes(allVals, getVal(rowData));
}, () => `the combination of ${_.join(_.dropRight(colNames, 1), ", ")} and ${_.last(colNames)} has to be unique`);

const VendorPidColorSizeUniqValidator = new Validator((val, rowData, dataset) => {
  let getVal = row => {
    if (_.isEmpty(_.get(row, "SizeDetails"))) {
      return [`${_.get(row, "VendorPid")},${_.get(row, "NrfColor")},${_.get(row, "NrfSize")}`];
    } else {
      return _.chain(row).get("SizeDetails").map("NrfSize").map(a => `${_.get(row, "VendorPid")},${_.get(row, "NrfColor")},${a}`).value();
    }
  };

  const allVals = _.chain(dataset)
      .reject(a => new RegExp(`^(${_.get(rowData, "ImportRowNo")}\/.+$|${_.get(rowData, "ImportRowNo")}$)`).test(_.get(a, "ImportRowNo")))
      .map(getVal).flatten().compact().uniq().value();

  return _.chain(allVals).intersection(getVal(rowData)).isEmpty().value();
},
`the combination of Vendor PID, NrfColor and NrfSize has to be unique`
);

const maxLengthValidator = colName => length => new Validator(
    (val) => _.chain(val).get("length", 0).lte(length).value(),
    `${colName} should have max ${length} characters`
    );

export const columnValidators = {
  'Cost': new Validators([
    requiredValidator('Cost'),
    dollarValidator('Cost'),
    positiveNumberValidator('Cost')
  ]),
  'CompareAt': new Validators([
    requiredValidator('Compare At'),
    dollarValidator('Compare At')
  ]),
  'TicketRetail': new Validators([
    requiredValidator('Ticket Retail'),
    dollarValidator('Ticket Retail'),
    positiveNumberValidator('Ticket Retail')
  ]),
  'MbksStyleSeq': new Validators([
    requiredValidator('Style seq'),
    uniqValidator('MbksStyleSeq')('Style seq')
  ]),
  'Quantity': new Validators([
    requiredValidator('Quantity'),
    integerValidator('Quantity'),
    positiveNumberValidator('Quantity')
  ]),
  'VendorPid': new Validators([
    requiredValidator('Vendor Pid'),
    VendorPidColorSizeUniqValidator
  ]),
  'VendorPidDesc': new Validators([
    requiredValidator('Vendor Pid Description')
  ]),
  /*'MbksPid': new Validators([
    requiredValidator
  ]),
  'MbksPidDesc': new Validators([
    requiredValidator
  ]),*/
  'MbksClass': new Validators([
    requiredValidator('Class'),
    numericValueValidator('Class')
  ]),
  'MbksSubClass': new Validators([
    numericValueValidator('Sub-Class')
  ]),
  'AndUp': new Validators([
    requiredValidator('And Up'),
    regexValidator('And Up', /^[YN]$/)
  ]),
  'Source': new Validators([
    requiredValidator('Source'),
    numericValueValidator('Source')
  ]),
  'Season': new Validators([
    requiredValidator('Season'),
    numericValueValidator('Season')
  ]),
  'MultiOf': new Validators([
    requiredValidator('Multi Of')
  ]),
  'TicketType': new Validators([
    requiredValidator('Ticket Type')
  ]),
  'MasterStyleDiv': new Validators([
    // requiredValidator
  ]),
  'MasterStyle': new Validators([
    // requiredValidator
  ]),
  'NrfSize': new Validators([
    new Validator((value, rowData) => {
      return rowData.isVendorUpcMode ? !_.isNil(value) && !_.eq(value, "") : true
    }, 'NrfSize is required'),
    VendorPidColorSizeUniqValidator
  ]),
  'NrfSizeName': new Validators([
    new Validator((value, rowData) => {
      return rowData.isVendorUpcMode ? !_.isNil(value) && !_.eq(value, "") : true
    }, 'NrfSizeName is required')
  ]),
  /* 'MasterStyleName': new Validators([
     requiredValidator
   ]),*/
  'NrfColor': new Validators([
    numericValueValidator("Color"),
    VendorPidColorSizeUniqValidator,
    requiredValidator('NrfColor')
  ]),
  /*'MbksMarkStyleNo': new Validators([
    requiredValidator
  ]),*/
  'MbksMarkStyleName': new Validators([
    requiredValidator('MbksMarkStyleName'),
    alphaNumericValueValidator('MKST Desc')
  ]),
  'VendorUpc': new Validators([
    new Validator((value, rowData) => {
      return rowData.isVendorUpcMode ? !_.isNil(value) && !_.eq(value, "") : true
    }, 'VendorUpc is required')
  ]),
  'CompareAtSource': new Validators(
    [
      requiredValidator('Compare at Source'),
      numericValueValidator('Compare at Source')
    ]
  ),
  'CompareAtNotes': new Validators([
    new Validator(
      (value, rowData) => {
        const isRequired = _.includes([1, 2, 3], _.get(rowData, "CompareAtSource"));
        return isRequired ? !_.isNil(value) && !_.eq(value, "") : true;
      },
      'Compare at Notes is required when Compare at Source is Vendor, Competitor or Other'
    )
  ]),
  'AllocationNotes': new Validators([
    maxLengthValidator("Allocation Notes")(30),
    alphaNumericValueValidator("Allocation Notes")
  ])
  /*  'CorpInHouseUpc': new Validators([
      requiredValidator
    ])*/
}

export const cdpProductColumnValidators = {
  'SellingDeptNo': new Validators([
    requiredValidator('Selling Dept'),
    maxLengthValidator("Selling Dept")(4)
  ]),
  'SellingVendorNo': new Validators([
    requiredValidator('Selling Vend'),
    maxLengthValidator("Selling Vend")(4)
  ]),
  'SellingPid': new Validators([
    requiredValidator('Selling PID'),
    alphaNumericValueValidator('Selling PID')
  ]),
  'SellingNrfColor': new Validators([
    maxLengthValidator("Selling NRF Color")(3)
  ]),
  'SellingNrfSize': new Validators([
    alphaNumericValueValidator('Selling NRF Size')
  ]),
  'SellingClass': new Validators([
    alphaNumericValueValidator('Selling Class')
  ]),
  'SellingSubClass': new Validators([
    alphaNumericValueValidator('Selling SubCl')
  ]),
  'TicketRetail': new Validators([
    requiredValidator('Buying Ticket Retail'),
    dollarValidator('Buying Ticket Retail'),
    positiveNumberValidator('Buying Ticket Retail')
  ]),
  'Cost': new Validators([
    requiredValidator('CDP Cost'),
    dollarValidator('CDP Cost'),
    positiveNumberValidator('CDP Cost')
  ]),
  'MbksPid': new Validators([
    alphaNumericValueValidator('Buying PID')
  ]),
  'MbksPidDesc': new Validators([
    requiredValidator('Buying PID Desc'),
    alphaNumericValueValidator('Buying PID Desc')
  ]),
  'MbksClass': new Validators([
    requiredValidator('Class'),
    numericValueValidator('Class')
  ]),
  'MbksSubClass': new Validators([
    numericValueValidator('Sub-Class')
  ]),
  'AndUp': new Validators([
    requiredValidator('And Up'),
    regexValidator('And Up', /^[YN]$/)
  ]),
  'Source': new Validators([
    requiredValidator('Source'),
    numericValueValidator('Source')
  ]),
  'Season': new Validators([
    requiredValidator('Season'),
    numericValueValidator('Season')
  ]),
  'MultiOf': new Validators([
    requiredValidator('Multi Of')
  ]),
  'TicketType': new Validators([
    requiredValidator('Ticket Type')
  ]),
  'NrfSizeName': new Validators([
    alphaNumericValueValidator('Buying Size Desc')
  ]),
  'NrfColor': new Validators([
    numericValueValidator("Color"),
    VendorPidColorSizeUniqValidator,
    requiredValidator('NrfColor')
  ]),
  'MbksMarkStyleName': new Validators([
    requiredValidator('MbksMarkStyleName'),
    alphaNumericValueValidator('MKST Desc')
  ]),
  'VendorUpc': new Validators([
    new Validator((value, rowData) => {
      return rowData.isVendorUpcMode ? !_.isNil(value) && !_.eq(value, "") : true
    }, 'VendorUpc is required')
  ]),
  'CompareAtSource': new Validators(
    [
      requiredValidator('Compare at Source'),
      numericValueValidator('Compare at Source')
    ]
  ),
  'AllocationNotes': new Validators([
    maxLengthValidator("Allocation Notes")(30),
    alphaNumericValueValidator("Allocation Notes")
  ]),
  'PurchaseQty': new Validators([
    requiredValidator('Purchase QTY'),
    integerValidator('Purchase QTY'),
    positiveNumberValidator('Purchase QTY')
  ])
}

export const headerFieldsValidators = {
  RequestHeaderName: new Validators([
    requiredValidator('RequestHeaderName')
  ]),
  DeptNo: new Validators([
    requiredValidator('DeptNo')
  ]),
  VendorNo: new Validators([
    requiredValidator('VendorNo')
  ]),
  MaycsNetRouteDate: new Validators([
    requiredValidator('MaycsNetRouteDate')
  ]),
  IndcDate: new Validators([
    requiredValidator('IndcDate')
  ]),
  CancelDate: new Validators([
    requiredValidator('CancelDate')
  ]),
  DistroByDate: new Validators([
    requiredValidator('DistroByDate')
  ]),
  PreTicket: new Validators([
    requiredValidator('PreTicket')
  ]),
  TicketType: new Validators([
    requiredValidator('TicketType')
  ]),
};

// usage
// const validity = columnValidators.Cost.getValidity(value)

// validity.isValid()
// validity.getErrorMessages()



// WEBPACK FOOTER //
// ./utilities/validators.js